import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"

export const PaginationDots = styled(Horizontal)`
  gap: 2px;

  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);

  pointer-events: none;
`

export const PaginationDot = styled.div<{ active: boolean }>`
  width: 20px;
  height: 20px;

  cursor: pointer;
  pointer-events: auto;

  position: relative;

  &::before {
    content: '';

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 8px;
    height: 8px;

    border-radius: var(--border-radius-round);

    background-color: ${props => props.active
      ? "var(--text-color-30)"
      : "var(--text-color-10)"};

    transition: background-color 0.2s ease;
  }

  &:hover::before {
    background-color: var(--text-color-20);
  }
`
